export enum ErrorStatus {
  NOT_FOUND = "Seems like you're lost ",
  ERROR = 'Page crashed',
  UNAUTHORIZED = 'Unauthorized',
  UNAUTHENTICATED = "Oops! You're not signed in",
  BOOKING_CLOSED = 'We are currently closed',
}

export enum ErrorMessage {
  NOT_FOUND = 'Page not found',
  ERROR = 'Oops, an error occurred!',
  UNAUTHORIZED = `You're not authorized to view this resource`,
  UNAUTHENTICATED = 'Please sign in to continue.',
  BOOKING_CLOSED = 'Follow us on instagram @braidsbytifeh to see updates on when we open again.',
}
